import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ICON_INACTIVE_COLOR } from '../../../../../utils';
import GhostBtn from '../../../buttons/GhostBtn/GhostBtn';
import { IMenuItemType } from '../MenuList';
import CSS from './Option.scss';
import { COLORS } from '../../../../../utils';
import Checkbox from '@/components/dom/Checkbox/Checkbox';
export var IOptionOverflowType;
(function (IOptionOverflowType) {
    IOptionOverflowType["ellipsis"] = "ellipsis";
})(IOptionOverflowType || (IOptionOverflowType = {}));
const Option = ({ id, testId = 'Option', icon: Icon, fontFamily, type, children, overflow, isActive, checkbox, rhsText, endButtonText = '', isHovered, isDivider = false, isIndented = false, onClick, iconOnClick, onMouseEnter, onMouseLeave, iconOnMouseLeave, iconOnMouseEnter, }) => {
    const textOverflow = overflow || 'hidden';
    const classes = [CSS.Option];
    let iconFill = isHovered ? COLORS.nebula : null;
    if (isActive) {
        classes.push(CSS.Active);
        iconFill = COLORS.nebula;
        if (checkbox)
            classes.push(CSS.NoActiveBorder);
    }
    if (isIndented) {
        classes.push(CSS.Indented);
    }
    if (!Icon)
        classes.push(CSS.HasNoIcon);
    switch (type) {
        case IMenuItemType.faded:
            classes.push(CSS.Faded);
            break;
        case IMenuItemType.disabled:
            classes.push(CSS.Disabled);
            iconFill = ICON_INACTIVE_COLOR;
            break;
        case IMenuItemType.danger:
            classes.push(CSS.Danger);
            iconFill = '#AF0B2B';
            break;
        case IMenuItemType.header:
            classes.push(CSS.Header, CSS.IsHeader);
            iconFill = null;
            break;
        default:
            break;
    }
    return isDivider ? (_jsx("div", { className: CSS.Divider })) : (_jsxs("div", { className: classes.join(' '), "data-testid": testId, onClick: () => {
            if (type !== IMenuItemType.disabled && type !== IMenuItemType.header)
                onClick(id);
        }, onMouseEnter: () => onMouseEnter?.(), onMouseLeave: () => onMouseLeave?.(), title: children, children: [checkbox && _jsx("div", { style: { margin: '0 8px' }, children: _jsx(Checkbox, { checked: isActive, onChange: () => { } }) }, "checkbox"), Icon && !checkbox && (_jsx("div", { className: `${CSS.IconContainer} ${!!endButtonText ? CSS.ButtonAtEndOption : ''}`, onMouseEnter: () => {
                    if (iconOnMouseEnter)
                        iconOnMouseEnter();
                }, onMouseLeave: () => {
                    if (iconOnMouseLeave)
                        iconOnMouseLeave();
                }, children: _jsx(Icon, { className: CSS.OptionIcon, hexFill: iconFill ?? undefined, onClick: (e) => {
                        if (iconOnClick) {
                            e.preventDefault();
                            e.stopPropagation();
                            iconOnClick(id);
                        }
                    } }) }, "icon")), _jsxs("div", { className: CSS.Container, children: [_jsx("span", { className: overflow ? CSS.Overflow : undefined, style: fontFamily ? Object.assign({ textOverflow }, { fontFamily }) : { textOverflow }, children: children }), isHovered && !!endButtonText && _jsx(GhostBtn, { style: { padding: `4px 14px`, marginLeft: `10px` }, children: endButtonText })] }), !!rhsText && _jsx("div", { className: CSS.RightSideDiv, children: rhsText })] }));
};
export default Option;
